import { DataLayerWindow } from '../../index';
import { DataLayerAnalytics } from '../pages/landing-page/models/analytics.interface';

export const setAdobeAnalytics = (event: DataLayerAnalytics) => {
  const dataLayerWindow = window as unknown as DataLayerWindow;
  dataLayerWindow.adobeDataLayer = dataLayerWindow.adobeDataLayer || [];
  dataLayerWindow.adobeDataLayer.push(event);
};
